/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { tagName } from '@ember-decorators/component';
import { observes } from '@ember-decorators/object';
import { action } from '@ember/object';
import Component from '@ember/component';
import ace from 'ace/ace';

@tagName('')
export default class AceEditor extends Component {
  hasError = false;
  toggleAction = null;

  didInsertElement() {
    super.didInsertElement(...arguments);

    let editor = (window.aceEditorInstance = ace.edit('email-html'));

    editor.setTheme('ace/theme/merbivore_soft');

    let editorSession = editor.getSession();

    editorSession.setUseWrapMode(true);
    editorSession.setUseWorker(false);
    editorSession.setMode('ace/mode/html');
    editorSession.setValue(this.get('editorContent'));
    editor.on('change', () => {
      this.set('editorContent', window.aceEditorInstance.getValue());
    });
  }

  willDestroyElement() {
    window.aceEditorInstance = null;
  }

  @observes('editorContent')
  clearError() {
    this.set('hasError', false);
  }

  @action
  toggleEditor() {
    this.toggleAction();
  }
}
